// extracted by mini-css-extract-plugin
module.exports = {"defaultTheme":"themes_defaultTheme__2nKYs","darkTheme":"themes_darkTheme__hsZqC"};